import React from "react"

import { BaseButton } from "@components/base-button"

import * as styles from "./request-trade-account.module.css"

const RequestTradeAccount = () => {
  return (
    <div className={styles.container}>
      <div className={styles.title}>Request Trade Account</div>
      <div className={styles.text}>
        There are many benefits, once you&apos;ve built a history with us you
        can apply for an account.
      </div>
      <div className={styles.buttons}>
        <BaseButton type="link" to="/trade-account" variant="accent">
          Apply for trade account
        </BaseButton>
        <BaseButton type="link" to="/contact-us" variant="secondary">
          Contact Us
        </BaseButton>
      </div>
    </div>
  )
}

export default RequestTradeAccount
